import DetailPageLayout from "../Layout/DetailPageLayout";
import { useState } from "react";
import { findAccountAtom } from "../../recoil/atoms";
import { useRecoilState } from "recoil";
import { TextM, TextMS, TextS } from "../../common/text";
import {
  FormControl,
  FormHelperText,
  IconButton,
  InputAdornment,
  InputLabel,
  OutlinedInput,
} from "@mui/material";
import { Visibility, VisibilityOff } from "@mui/icons-material";

import {
  ContentContainer,
  Header,
  NextButton,
  NextButtonText,
  Wrapper,
} from "./FindAccountNewPassword.styles";
import { useResetPassword } from "./FindAccountNewPassword.helpers";
import { TailSpin } from "react-loader-spinner";

const passwordRegex =
  /^(?=.*[A-Za-z])(?=.*\d)(?=.*[\{\}\[\]\/?.,;:|\)*~`!^\-_+<>@\#$%&\\\=\(\'\"])[A-Za-z\d\{\}\[\]\/?.,;:|\)*~`!^\-_+<>@\#$%&\\\=\(\'\"]{8,}$/;

const FindAccountNewPassword = () => {
  const [{ phone, authenticationNumber, username }, setFindAccountAtom] =
    useRecoilState(findAccountAtom);
  const [password, setPassword] = useState("");
  const [passwordMessage, setPasswordMessage] = useState("");
  const [_, setPasswordConfirm] = useState("");
  const [passwordConfirmMessage, setPasswordConfirmMessage] = useState("");
  const [isValidPassword, setIsValidPassword] = useState(false);
  const [isValidPasswordConfirm, setIsValidPasswordConfirm] = useState(false);
  const { mutate: resetPassword, isLoading } = useResetPassword();

  // mui 비밀번호 확인 관련
  const [showPassword, setShowPassword] = useState(false);
  const [showPasswordConfirm, setShowPasswordConfirm] = useState(false);
  const handleClickShowPassword = () => {
    setShowPassword(!showPassword);
  };
  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };
  const handleClickShowPasswordConfirm = () => {
    setShowPasswordConfirm(!showPasswordConfirm);
  };
  const handleMouseDownPasswordConfirm = (event) => {
    event.preventDefault();
  };

  const goNext = () => {
    if (isValidPassword && isValidPasswordConfirm) {
      resetPassword({ password, phone, authenticationNumber });
    }
  };

  // 비밀번호 입력 핸들러
  const onPasswordChange = (e) => {
    const currentPassword = e.target.value;
    setPassword(currentPassword);

    if (!passwordRegex.test(currentPassword)) {
      setPasswordMessage("사용할 수 없는 비밀번호입니다");
      setIsValidPassword(false);
    } else {
      setPasswordMessage("사용가능한 비밀번호입니다.");
      setIsValidPassword(true);
    }
    if (currentPassword.length === 0) {
      setPasswordMessage("");
    }
  };
  // 비밀번호재입력 핸들러
  const onPasswordConfirmChange = (e) => {
    const currentPasswordConfirm = e.target.value;
    setPasswordConfirm(currentPasswordConfirm);

    if (password !== currentPasswordConfirm) {
      setIsValidPasswordConfirm(false);
      if (currentPasswordConfirm.length === 0) {
        setPasswordConfirmMessage("");
      } else {
        setPasswordConfirmMessage("비밀번호가 일치하지 않습니다.");
      }
    } else {
      if (isValidPassword) {
        setIsValidPasswordConfirm(true);
      }

      if (currentPasswordConfirm.length === 0) {
        setPasswordConfirmMessage("");
      } else {
        setPasswordConfirmMessage("비밀번호가 일치합니다.");
      }
      setFindAccountAtom((prev) => ({
        ...prev,
        newPassword: currentPasswordConfirm,
      }));
    }
  };

  return (
    <DetailPageLayout headerText={"새 비밀번호 입력"}>
      <ContentContainer>
        <Header>
          <TextM>{username}님</TextM>
          <TextM>비밀번호를 재설정해주세요</TextM>
          <br />
          <TextMS color="#f44b59">
            영문 / 숫자 / 특수문자 포함하여 <br />
            8자 이상인 비밀번호를 입력해주세요.
          </TextMS>
        </Header>
        <Wrapper>
          <FormControl style={{ width: "100%" }} variant="outlined">
            <InputLabel htmlFor="outlined-adornment-password">
              비밀번호
            </InputLabel>
            <OutlinedInput
              id="outlined-adornment-password-confirm"
              type={showPassword ? "text" : "password"}
              endAdornment={
                <InputAdornment position="end">
                  <IconButton
                    aria-label="toggle password visibility"
                    onClick={handleClickShowPassword}
                    onMouseDown={handleMouseDownPassword}
                    edge="end"
                  >
                    {showPassword ? <VisibilityOff /> : <Visibility />}
                  </IconButton>
                </InputAdornment>
              }
              label={"비밀번호"}
              onChange={onPasswordChange}
            />
            {passwordMessage && (
              <FormHelperText error id="password-error">
                <TextS color="#f44b59">{passwordMessage}</TextS>
              </FormHelperText>
            )}
          </FormControl>
          <FormControl style={{ width: "100%" }} variant="outlined">
            <InputLabel htmlFor="outlined-adornment-password">
              비밀번호 재입력
            </InputLabel>
            <OutlinedInput
              id="outlined-adornment-password"
              type={showPasswordConfirm ? "text" : "password"}
              endAdornment={
                <InputAdornment position="end">
                  <IconButton
                    aria-label="toggle password visibility"
                    onClick={handleClickShowPasswordConfirm}
                    onMouseDown={handleMouseDownPasswordConfirm}
                    edge="end"
                  >
                    {showPasswordConfirm ? <VisibilityOff /> : <Visibility />}
                  </IconButton>
                </InputAdornment>
              }
              label="비밀번호재입력"
              onChange={onPasswordConfirmChange}
              helper
            />
            {passwordConfirmMessage && (
              <FormHelperText error id="password-confirm-error">
                <TextS color="#f44b59">{passwordConfirmMessage}</TextS>
              </FormHelperText>
            )}
          </FormControl>
        </Wrapper>

        <NextButton isValidPassword={isValidPasswordConfirm && isValidPassword}>
          {isLoading ? (
            <TailSpin height={"35px"} width={"35px"} color={"white"}></TailSpin>
          ) : (
            <NextButtonText
              onClick={goNext}
              isValidPassword={isValidPasswordConfirm && isValidPassword}
            >
              다음
            </NextButtonText>
          )}
        </NextButton>
      </ContentContainer>
    </DetailPageLayout>
  );
};

export default FindAccountNewPassword;
